import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import type { FaqItem } from '../types/content';
interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number;
}
export function FaqAccordion({
  items,
  defaultOpen = 0
}: FaqAccordionProps) {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);
  return <ul className="divide-y divide-navy/10 border-y border-navy/10" data-id="element-58" data-mp="3ni0cbiy1fz28">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <li key={item.question.en} data-id="element-59" data-mp="1blma6057pzy" data-mpi={index}>
            <h3 data-id="element-60" data-mp="1akafzbayzh6">
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-61" data-mp="3siy5eqkl6dii">
                <span className="font-display text-lg leading-snug text-navy" data-id="element-62" data-mp="3cg5g2qbsbyfa">
                  {t(item.question)}
                </span>
                <span className={['mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out-expo', isOpen ? 'bg-navy text-gold' : 'bg-navy-100 text-navy'].join(' ')} aria-hidden="true" data-id="element-63" data-mp="3gia85kml4mzt">
                  {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-64" data-mp="3zkgu18ygjpd" /> : <PlusIcon className="h-4 w-4" data-id="element-65" data-mp="3yiu2ziku8rt" />}
                </span>
              </button>
            </h3>
            {isOpen ? <div id={`faq-panel-${index}`} className="pb-6 pr-12" data-id="element-66" data-mp="7zuk365d4w0j">
                <p className="max-w-3xl leading-relaxed text-ink/75" data-id="element-67" data-mp="d08ngaw0rhs8">{t(item.answer)}</p>
              </div> : null}
          </li>;
    })}
    </ul>;
}